import type { Step } from "react-joyride";

export const leaveTypesTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າປະເພດລາ. ຈັດການປະເພດລາ (ມ.ກ., ກ.ພ., ...) ສ້າງ ແກ້ໄຂ ເບິ່ງລາຍລະອຽດ. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="leave-types-toolbar"]',
    content: "ຫົວຂໍ້ ແລະ ປຸ່ມສ້າງປະເພດລາໃໝ່.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="leave-types-table"]',
    content: "ຕາຕະລາງປະເພດລາ. ກົດເບິ່ງ ຫຼື ແກ້ໄຂ.",
    placement: "top",
  },
];
